// import React, { useState } from "react";
// import { Helmet } from "react-helmet"; // Helmet import

import RandingStyle10 from "../../randing/RandingStyle10";

function Randing055({ urlCode, urlCodeSettingId }) {
  return (
    <>
      <RandingStyle10
        urlCode={urlCode}
        urlCodeSettingId={urlCodeSettingId}
        img1Path={`${process.env.REACT_APP_CDN_BASE}/images/055/25010301.gif`}
        videoPath={`${process.env.REACT_APP_CDN_BASE}/images/055/25010302.mp4`}
        qOptionColor="blue"
        formFieldColor="white"
        postBTN={`${process.env.REACT_APP_CDN_BASE}/images/013/241118_07.png`}
        companyName="본원"
        // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/ggul.jpg`}
      />
    </>
  );
}

export default Randing055;
